var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldCircleCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Shield with Checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "twoTonePrimary",
    d: "M36.1,19.8c0,16.7-14.7,23.1-17.1,24c-2.3-1-17.1-7.6-17.1-24V5.7L19,2.1l17.1,3.6V19.8z M19,0.2l-19,4v15.6   c0,19,18.5,25.9,18.7,25.9l0.3,0.1l0.3-0.1C19.5,45.7,38,39.1,38,19.8V4.2L19,0.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "twoToneSecondary",
    d: "m19 30.8c5.4 0 9.8-4.4 9.8-9.8s-4.4-9.8-9.8-9.8c-2.4 0-4.8 0.9-6.5 2.5-0.3 0.3-0.3 0.8 0 1.1s0.8 0.3 1.1 0c1.5-1.4 3.5-2.2 5.6-2.2 4.6 0 8.3 3.7 8.3 8.3s-3.7 8.3-8.3 8.3-8.3-3.7-8.3-8.3c0-1.4 0.3-2.7 1-3.9 0.1-0.3-0.1-0.8-0.4-1s-0.8-0.1-1 0.3c-0.8 1.4-1.2 3-1.2 4.7-0.1 5.5 4.3 9.8 9.7 9.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "twoToneSecondary",
    d: "m23 16.7c-0.3-0.2-0.7-0.1-0.9 0.3l-4.1 7-3.2-3.2c-0.3-0.3-0.7-0.3-0.9 0-0.3 0.3-0.3 0.7 0 1l4 4c0.2 0.2 0.5 0.2 0.8 0l0.1-0.1 4.5-8c0.1-0.4 0-0.9-0.3-1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCircleCheckmark);
export default __webpack_public_path__ + "static/media/shield-circle-checkmark.20f9bf563e4e6296a72d62fbceb2929c.svg";
export { ForwardRef as ReactComponent };